import React from 'react';
import { useAuth } from '../../Context/ContextProvider';
import { Link } from 'react-router-dom';
import dummyImage from '../../Assete/dummy image.png';
import DescriptionForMedia from '../Metiral/DescriptionForMedia';
function MediaRoom({ latestStory }) {
    // Sample data (kept from original implementation)


    const { base_url } = useAuth();

    const dateFormate = (date) => {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // Returns a human‑readable "time ago" string
    const timeAgo = (time) => {
        if (!time) return '';
        const now = new Date();
        const diffSec = Math.floor((now - new Date(time)) / 1000);
        if (diffSec < 60) return 'just now';
        const diffMin = Math.floor(diffSec / 60);
        if (diffMin < 60) return `${diffMin} minute${diffMin !== 1 ? 's' : ''} ago`;
        const diffHr = Math.floor(diffMin / 60);
        if (diffHr < 24) return `${diffHr} hour${diffHr !== 1 ? 's' : ''} ago`;
        const diffDay = Math.floor(diffHr / 24);
        if (diffDay < 30) return `${diffDay} day${diffDay !== 1 ? 's' : ''} ago`;
        const diffMonth = Math.floor(diffDay / 30);
        if (diffMonth < 12) return `${diffMonth} month${diffMonth !== 1 ? 's' : ''} ago`;
        const diffYear = Math.floor(diffMonth / 12);
        return `${diffYear} year${diffYear !== 1 ? 's' : ''} ago`;
    };

    // Use the passed in latestStory if provided, otherwise fall back to the static data above
    // const stories = latestStory?.length ? latestStory : data;

    return (
        <div className="media_room pb-5 px-lg-4 px-0">
            <div className="container">
                <h4 className='text-center'>Media Room</h4>
                <p className="pera text-center">Professors' Stories: Inspiration from the Forefront of Medicine</p>
                <div className="grid">
                    {latestStory?.map((item) => (
                        <Link to={`/media-detail/${item?._id}`} key={item.name}>

                            <div className="story_card" key={item.name}>
                                <div className="img">
                                    <img src={item?.userPicture ? item?.userPicture : dummyImage} alt="..." />
                                </div>
                                <div className="p-2">
                                    <div className="d-flex justify-content-between">
                                        <span>{dateFormate(item?.createdAt)}</span>
                                        <span>{timeAgo(item?.createdAt)}</span>
                                    </div>
                                    <h6 className="mt-2">{item?.name}</h6>
                                    <DescriptionForMedia content={item?.storyContent} />
                                    {/* <div dangerouslySetInnerHTML={{ __html: item?.storyContent }} /> */}
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default MediaRoom;